import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconCheck({ strokeWidth = 2, ...props }: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.5 5.5L4.5 8.5L10.5 2.5" stroke="currentColor" strokeWidth={strokeWidth} />
    </SVGIcon>
  );
}
